function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M69.23 0H6.77C3.06 0 .09 2.43 0 5.58v45.74C0 54.45 3 57 6.77 57H36v11H18.5a1.5 1.5 0 000 3h39a1.5 1.5 0 000-3H39V57h30.23C73 57 76 54.45 76 51.32V5.68C76 2.55 73 0 69.23 0zM73 51.32c0 1.45-1.73 2.68-3.77 2.68H6.77C4.77 54 3 52.77 3 51.32V5.62C3 4.18 4.73 3 6.77 3h62.46c2 0 3.77 1.23 3.77 2.68z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M43.27 19.63a1.5 1.5 0 00-2 .65L33.19 36a1.5 1.5 0 102.67 1.37l8.06-15.75a1.5 1.5 0 00-.65-1.99zM52.86 19.08a1.5 1.5 0 00-2.12 2.12l7.48 7.47-7.48 7.47a1.5 1.5 0 102.12 2.12l8.54-8.53a1.5 1.5 0 000-2.12zM26.4 19.08a1.5 1.5 0 00-2.12 0l-8.54 8.54a1.5 1.5 0 000 2.12l8.54 8.54a1.5 1.5 0 002.12-2.12l-7.48-7.47 7.48-7.49a1.5 1.5 0 000-2.12z"
});

var SvgWeb = function SvgWeb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 71,
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    viewBox: "0 0 76 71",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWeb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/web.806ecc2e.svg";
export { ForwardRef as ReactComponent };